import { Outlet, useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/admin-design/_common'
import { LayoutDashboard, Server, Rocket, Globe, Database, Gauge, Activity, Settings } from 'lucide-react'
import { api } from '@/api/client'
import DeployToast from './DeployToast'

const navItems = [
  { to: '/', label: 'Dashboard', end: true, icon: <LayoutDashboard size={14} aria-hidden="true" /> },
  { to: '/services', label: 'Services', icon: <Server size={14} aria-hidden="true" /> },
  { to: '/deploy', label: 'Deploy', icon: <Rocket size={14} aria-hidden="true" /> },
  { to: '/domains', label: 'Domains', icon: <Globe size={14} aria-hidden="true" /> },
  { to: '/db', label: 'DB Viewer', icon: <Database size={14} aria-hidden="true" /> },
  { to: '/monitoring', label: 'Monitoring', icon: <Gauge size={14} aria-hidden="true" /> },
  { to: '/jobs', label: 'Jobs', icon: <Activity size={14} aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', icon: <Settings size={14} aria-hidden="true" /> },
]

export default function Layout() {
  const nav = useNavigate()
  const onLogout = async () => {
    try {
      await api.logout()
    } finally {
      nav('/login')
    }
  }
  return (
    <AdminLayout brand="InfraAdmin" navItems={navItems} onLogout={onLogout}>
      <Outlet />
      <DeployToast />
    </AdminLayout>
  )
}
